import { render, staticRenderFns } from "./room_type_set.vue?vue&type=template&id=650cce9b"
import script from "./room_type_set.vue?vue&type=script&lang=js"
export * from "./room_type_set.vue?vue&type=script&lang=js"
import style0 from "./room_type_set.vue?vue&type=style&index=0&id=650cce9b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports